export const scrollToTop = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollTop = 0;
};
